const CONSENT_STORAGE_KEY = "ngw_cookie_consent";

// Storing the visitor's own cookie-preference choice is itself
// strictly-necessary storage and requires no consent gating.
export function getStoredConsent() {
  try {
    const value = localStorage.getItem(CONSENT_STORAGE_KEY);
    return value === "granted" || value === "denied" ? value : null;
  } catch {
    return null;
  }
}

export function setStoredConsent(value) {
  try {
    localStorage.setItem(CONSENT_STORAGE_KEY, value);
  } catch {
    // storage may be unavailable (private browsing, etc.) — the choice just
    // won't persist across reloads in that case
  }
}
